import { useEffect, useState } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useHistory, useLocation } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UploadData = () => {
  const [uploads, setUploads] = useState([]);

  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [existingFiles, setExistingFiles] = useState([]);
  const history = useHistory();
  const location = useLocation();
  const { folderName, space, list } = location.state || {};

  const BASE_URL = process.env.REACT_APP_BE_MAIN_URL;
  const GET_IMAGES_API = `${BASE_URL}/ocr/getimages/`;
  const GET_FILES_API = `${BASE_URL}/ocr/getfiles/`;
  const UPLOAD_API = `${BASE_URL}/ocr/file_upload/`;
  const RUN_TASK_API = `${BASE_URL}/ocr/run-task-now/`;


  const fetchExistingFiles = async () => {

    const token = sessionStorage.getItem("userToken");
    if (!token) {
      toast.error("Authentication token missing 😢");
      return;
    }

    try {
      const res = await axios.get(GET_FILES_API, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Filter the correct folder (match folder_name & space_path)
      const folderData = res.data.find(
        (f) => f.folder_name === folderName && f.space_path === list.join("/")
      );

      if (folderData?.files?.length > 0) {
        setExistingFiles(folderData.files);
      } else {
        setExistingFiles([]);
      }
    } catch (err) {
      console.error("❌ Error fetching files:", err);
      toast.error("Failed to fetch existing files ");
    }
  };

  const getExistingImages = async () => {
    setLoading(true);
    const token = sessionStorage.getItem("userToken");
    if (!token) {
      toast.error("Authentication token missing 😢");
      return;
    }

    try {
      const res = await axios.get(GET_IMAGES_API, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await fetchExistingFiles();

      const checkDataIsThere = res.data.filter(
        (images) => images.space_path == list.join("/")
      );


      console.log(checkDataIsThere, "checkDataIsThere")
      const hasDrawingImages = checkDataIsThere[0].files.some(
        (file) => file?.image_sets?.Drawing?.length > 0
      )

      if (hasDrawingImages) {
        history.push({
          pathname: "Drawingsbollon",
          state: {
            files: checkDataIsThere[0].files,
          },
        });
      }
      setLoading(false);
    } catch (err) {
      console.error("❌ Error fetching files:", err);
      toast.error("Failed to fetch existing files ");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (folderName && space) {
      getExistingImages();
      // fetchExistingFiles();
    }
  }, [folderName, space]);

  const handleFileSelect = (selected) => {
    const newFiles = Array.from(selected).map((f) => ({
      file: f,
      progress: 0,
      status: "pending",
    }));
    setUploads((prev) => [...prev, ...newFiles].slice(0, 5));
  };

  const formatSize = (bytes) => {
    if (bytes < 1024) return `${bytes}b`;
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)}kb`;
    return `${(bytes / (1024 * 1024)).toFixed(1)}MB`;
  };




  const handleUpload = async () => {
    if (uploads.length === 0) {
      toast.warning("Please select at least one file");
      return;
    }

    if (!folderName || !space) {
      toast.error(
        "Folder information is missing. Please go back and select a folder."
      );
      return;
    }

    const token = sessionStorage.getItem("userToken");
    if (!token) {
      toast.error("Authentication token missing");
      return;
    }

    try {
      setUploading(true);
      const formData = new FormData();

      // const transformSpacePathToLevels = space.split("/");
      // ✅ Just send folder and space_path directly
      formData.append("folder_name", folderName);

      // adding levels
      const totalLevels = 8;

      for (let i = 0; i < totalLevels; i++) {
        const key = `level${i + 1}`;
        const value = list[i] ?? "";
        formData.append(key, value);
      }

      // Attach files
      uploads.forEach((u) => {
        formData.append("files", u.file, u.file.name);
      });

      // uploads.forEach((u) => {
      //   formData.append("files", u.file);
      // });

      const response = await axios.post(UPLOAD_API, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        onUploadProgress: (e) => {
          const percent = Math.round((e.loaded * 100) / e.total);
          setUploads((prev) =>
            prev.map((item) => ({ ...item, progress: percent }))
          );
        },
      });


      toast.success("✅ Files uploaded successfully!");

      // Refresh the file list
      await fetchExistingFiles();
      setUploads([]);
    } catch (err) {
      console.error("Upload error:", err);
      toast.error(err.response?.data?.error || "Failed to upload files");
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = async () => {
    const token = sessionStorage.getItem("userToken");
    if (!token) {
      toast.error("Authentication token missing ");
      return;
    }

    try {
      setUploading(true);
      const res = await axios.get(RUN_TASK_API, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(" Task triggered successfully!");
    } catch (err) {
      console.error(" Error running task:", err);
      toast.error(err.response?.data?.error || "Failed to run task ");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <ToastContainer position="top-right" autoClose={1500} />

      {/* Header */}
      <header className="flex justify-between items-center p-4 border-b">
        <div className="flex items-center gap-2">
          <button
            onClick={() => window.history.back()}
            className="text-xl font-bold"
          >
            <IoIosArrowBack size={24} />
          </button>
          <h1 className="text-xl font-Montserrat">Upload Files</h1>
        </div>
      </header>

      {/* Content */}
      {loading ? (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-yellow-400"></div>
        </div>
      ) : (
        <main className="flex flex-col items-center justify-center flex-1">
          <h2 className="text-lg font-bold mb-2">Media Upload</h2>

          {/* Dropzone */}
          <div
            className="border-2 border-dashed border-gray-300 p-8 text-center rounded-lg cursor-pointer w-[32rem] max-w-full"
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              handleFileSelect(e.dataTransfer.files);
            }}
            onClick={() => document.getElementById("fileInput").click()}
          >
            <CloudUploadIcon className="mx-auto mb-2" fontSize="large" />
            <p className="text-gray-700">
              Drag your file(s) or{" "}
              <span className="text-teal-600 font-medium">browse</span>
            </p>
            <p className="text-gray-500 text-sm">Max 10 MB files are allowed</p>
          </div>

          <input
            id="fileInput"
            type="file"
            multiple
            className="hidden"
            onChange={(e) => handleFileSelect(e.target.files)}
          />

          {/* Pending uploads */}
          {uploads.length > 0 && (
            <ul className="mt-4 space-y-3 w-[28rem] max-w-full">
              {uploads.map((u, i) => (
                <li
                  key={i}
                  className="flex items-center justify-between bg-gray-50 border p-3 rounded-lg"
                >
                  <div className="w-full">
                    <p className="font-medium text-sm">{u.file.name}</p>
                    <p className="text-xs text-gray-500">
                      {formatSize(u.file.size)}
                    </p>
                    <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
                      <div
                        className={`h-2 rounded-full ${u.status === "error" ? "bg-red-500" : "bg-orange-500"
                          }`}
                        style={{ width: `${u.progress}%` }}
                      ></div>
                    </div>
                  </div>
                  <button
                    onClick={() =>
                      setUploads((prev) => prev.filter((_, idx) => idx !== i))
                    }
                    className="text-gray-500 hover:text-red-500 ml-2"
                  >
                    ×
                  </button>
                </li>
              ))}
            </ul>
          )}

          {/* Existing files */}
          {existingFiles.length > 0 ? (
            <div className="mt-8 w-[28rem] max-w-full">
              <h3 className="font-semibold mb-2 text-lg">📁 Existing Files:</h3>
              <ul className="space-y-2">
                {existingFiles.map((f, i) => (
                  <li
                    key={i}
                    className="text-sm text-blue-600 underline truncate"
                  >
                    <a
                      href={f.file_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {f.file_url.split("/").pop()}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <div className="text-gray-500 mt-8 text-sm">
              No files uploaded yet.
            </div>
          )}
          <div className="flex gap-4">
            <button
              disabled={uploading}
              onClick={handleUpload}
              className={`mt-6 w-48 max-w-full bg-[#FECF8B] text-black font-medium py-2 rounded-lg ${uploading ? "opacity-50 cursor-not-allowed" : ""
                }`}
            >
              {uploading ? "Uploading..." : "Upload"}
            </button>

            <button
              disabled={uploading || existingFiles.length === 0}
              onClick={handleSubmit}
              className={`mt-6 w-48 max-w-full bg-[#FECF8B] text-black font-medium py-2 rounded-lg ${uploading || existingFiles.length === 0
                  ? "opacity-50 cursor-not-allowed"
                  : ""
                }`}
            >
              {uploading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </main>
      )}
    </div>
  );
};

export default UploadData;
